import { inject, Injectable } from '@angular/core';
import type { DialogConfig, DialogRef } from '@angular/cdk/dialog';
import { Dialog } from '@angular/cdk/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { ComposableModalComponent } from '@app/components/modals/composable-modal/composable-modal.component';
import type { ComposableModalConfig } from '@app/components/modals/config/composable-modal.config';
import { DEFAULT_MODAL_CONFIG } from '@app/components/modals/config/composable-modal.config';
import App from '@app/app';
import { downgradeInjectable } from '@angular/upgrade/static';

@Injectable({
  providedIn: 'root'
})
export class ComposableModalService {
  private readonly dialog = inject(Dialog);
  private readonly overlay = inject(Overlay);

  openModal<T = unknown>(
    config: ComposableModalConfig,
    options?: DialogConfig
  ): DialogRef<T, ComposableModalComponent> {
    const finalConfig: ComposableModalConfig = {
      header: { ...DEFAULT_MODAL_CONFIG.header, ...config.header },
      detail: { ...DEFAULT_MODAL_CONFIG.detail, ...config.detail },
      buttons: { ...DEFAULT_MODAL_CONFIG.buttons, ...config.buttons }
    };

    return this.dialog.open(ComposableModalComponent, {
      data: finalConfig,
      backdropClass: options?.backdropClass ?? ['modal-backdrop', 'fade', 'in'],
      panelClass: options?.panelClass,
      width: options?.width ?? '400px',
      disableClose: options?.disableClose ?? false,
      scrollStrategy: this.overlay.scrollStrategies.noop()
    });
  }
}
App.factory('ComposableModalService', downgradeInjectable(ComposableModalService));
